import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useDeviceType } from "hooks";
import { theme } from "constants/theme";
import { CustomButtonSection } from "components/custom-button-section";
import desktopImageBackground from "assets/images/desktop-banner.png";
import mobileImageBackground from "assets/images/mobile-banner.png";
import buttonIcon from "assets/images/Listening Button.png";
import { Navbar } from "components/navbar/index";
import { NavId } from "types/navigation";
import close from "assets/images/close-icon.png";
import { Modal } from "components/modal";
import { CloseBlock } from "components/closemomileDetail";
import { fetchBlogs } from "services/blogService";
import { Blog } from "types/blog";
import { CustomHeadline, CustomText } from "components/ui";
import CardEffect from "../card-effect";
import { BlogViewer } from "./BlogViewer";
import SafeImage from "../SafeImage";

interface DetailPageProps {
  handleClose: (sectionId: string, sectionNumber: number) => void;
}

export const DetailPage13: React.FC<DetailPageProps> = ({ handleClose }) => {
  const [translate, setTranslate] = useState(0);
  const [activeSection, setActiveSection] = useState<number>(0);
  const { device } = useDeviceType();
  const isDesktop = device === "desktop";
  const navigate = useNavigate();
  const { customPath } = useParams();

  const [dynamicDefaultDesktopInner, setDynamicDefaultDesktopInner] =
    useState("");
  const [dynamicDefaultMobileInner, setDynamicDefaultMobileInner] =
    useState("");

  const [slug, setSlug] = useState<string>();

  useEffect(() => {
    if (customPath) {
      customPath && setSlug(customPath);
    }
  }, [customPath]);

  const todayEnd = new Date();
  todayEnd.setHours(23, 59, 59, 999);
  const [allBlogs, setAllBlogs] = useState<Blog[]>([]);
  const [filteredBlogs, setFilteredBlogs] = useState<Blog[]>([]);
  const [singleBlog, setSingleBlog] = useState<Blog>();
  const [loading, setLoading] = useState<boolean>(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchBlogs().then((data: Blog[]) => {
      setAllBlogs(data);
      const defaultImageData = data?.find((blog) => {
        return blog.status === "default-image";
      });
      setDynamicDefaultDesktopInner(
        defaultImageData?.desktopInnerImageUrl || ""
      );
      setDynamicDefaultMobileInner(defaultImageData?.mobileInnerImageUrl || "");
    });
  }, []);
  const previewPage = slug?.includes("preview-article");
  useEffect(() => {
    if (!allBlogs?.length) {
      return;
    }
    setFilteredBlogs(
      allBlogs.filter((blog: any) => {
        return blog.status === "publish";
      })
    );

    const slugName = slug?.includes("preview-article") ? slug?.slice(16) : slug;
    const index = allBlogs.findIndex((blog) => {
      return blog.slug === slugName;
    });
    const validIndex = index > -1 ? index : 0;

    setSingleBlog(allBlogs[validIndex]);
    setCurrentIndex(validIndex);
    setLoading(false);
  }, [allBlogs, slug]);

  const navigateToTop = () => navigate("/");

  const handleBack = () => {
    window.scrollTo(0, 0);
    const slugName = filteredBlogs[currentIndex - 1].slug;
    navigate(`/article/${slugName}`);
  };
  const handleForward = () => {
    window.scrollTo(0, 0);
    const slugName = filteredBlogs[currentIndex + 1].slug;
    if (slugName) {
      navigate(`/article/${slugName}`);
    }
  };

  return (
    <div className={styles.section13}>
      <Navbar
        activeSection={activeSection}
        navigateToTop={navigateToTop}
        theme="black"
        logoVariant="noLogoText"
        blur
      />
      <Modal setTranslate={setTranslate} setActiveSection={setActiveSection} />
      <div className={styles.container}>
        <img
          src={close}
          alt="img"
          className={styles.button}
          onClick={() =>
            !previewPage
              ? singleBlog
                ? navigate(`/blog#${singleBlog.slug}`)
                : navigate("/blog")
              : navigate("/admin-article")
          }
        />
        <div className={styles.content}>
          {loading && (
            <>
              <div className={styles.block1}>
                <div className={styles.skeletonLoader} />
              </div>
            </>
          )}
          {singleBlog && (
            <div className={styles.block1}>
              {!isDesktop && (
                <CloseBlock
                  id={NavId.Section11}
                  index={4}
                  handleClose={() =>
                    !previewPage
                      ? navigate(`/blog#${singleBlog.slug}`)
                      : navigate("/admin-article")
                  }
                />
              )}
              <div className={styles.centuries}>
                <CardEffect>
                  <CustomHeadline
                    size={isDesktop ? 32 : 24}
                    text={singleBlog.title}
                    color={theme.colors.neutral[20]}
                    styles={{
                      marginBottom: "10px",
                    }}
                  />

                  <div className={styles.p}>
                    <img src={buttonIcon} alt="buttonIcon" />
                    <CustomText
                      size={isDesktop ? 16 : 14}
                      text="Tap to hear this page come to life."
                      color={theme.colors.neutral[30]}
                      styles={{
                        fontStyle: "italic",
                        lineHeight: isDesktop ? "28px" : "18px",
                        fontWeight: "300",
                      }}
                    />
                  </div>
                </CardEffect>
                {/* <CardEffect> */}{" "}
                <BlogViewer blocks={singleBlog.customEditor.blocks} />
                {/* </CardEffect> */}
              </div>
            </div>
          )}
          <div className={styles.line}></div>
          {isDesktop && (
            <div className={styles.block2}>
              <div className={styles.links}>
                {filteredBlogs && filteredBlogs.length > 0 && (
                  <>
                    {filteredBlogs.map((item) => {
                      return (
                        <div
                          onClick={() =>
                            navigate(
                              previewPage
                                ? `/article/preview-article-${item.slug}`
                                : `/article/${item.slug}`
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <CustomText
                            text={item.title}
                            size={isDesktop ? 24 : 18}
                            color={theme.colors.green[90]}
                            styles={{
                              textAlign: isDesktop ? "left" : "center",
                              lineHeight: isDesktop ? 26 : 18 + "!impontant",
                            }}
                          />
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          )}
        </div>

        <div className={styles.blockButtons}>
          {!previewPage && currentIndex > 0 && (
            <CustomButtonSection
              text="Back"
              colorScheme="green"
              onClick={handleBack}
              style={{
                color: theme.colors.neutral[20],
                width: isDesktop ? "8.177dvw" : "120px",
                maxWidth: isDesktop ? "8.177dvw" : "120px",
              }}
            />
          )}
          {!previewPage && currentIndex < filteredBlogs.length - 1 && (
            <CustomButtonSection
              text="Forward"
              colorScheme="green"
              onClick={handleForward}
              style={{
                color: theme.colors.neutral[20],
                width: isDesktop ? "8.177dvw" : "120px",
                maxWidth: isDesktop ? "8.177dvw" : "120px",
              }}
            />
          )}
        </div>
      </div>
      {singleBlog && (
        <div className={styles.imageBox}>
          <CardEffect>
            <SafeImage
              src={
                device !== "desktop" && device !== "tablet"
                  ? singleBlog.mobileInnerImageUrl || dynamicDefaultMobileInner
                  : singleBlog.desktopInnerImageUrl ||
                    dynamicDefaultDesktopInner
              }
              fallback={
                device !== "desktop" && device !== "tablet"
                  ? dynamicDefaultMobileInner || mobileImageBackground
                  : dynamicDefaultDesktopInner || desktopImageBackground
              }
              alt={singleBlog.title}
            />
          </CardEffect>
        </div>
      )}
    </div>
  );
};
